import { jsx as _jsx } from "react/jsx-runtime";
import ConcordeEFB from "./ConcordeEFB";
const Root = () => _jsx(ConcordeEFB, {});
export default Root;
